import { BUSINESS } from "@/data/site";
import { Instagram } from "lucide-react";

export const Footer = () => (
  <footer className="bg-void border-t border-hairline" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 lg:py-20">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <img src={BUSINESS.logoDark} alt="Aims Electrical logo" className="h-12 w-auto" />
          <p className="text-concrete mt-5 max-w-xs leading-relaxed">
            Trusted domestic & commercial electricians serving {BUSINESS.region}. Fully insured.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={BUSINESS.socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram"
               className="grid place-items-center w-11 h-11 border border-hairline hover:border-brand hover:text-brand transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={BUSINESS.socials.yell} target="_blank" rel="noopener noreferrer" aria-label="Yell profile" data-testid="footer-yell"
               className="inline-flex items-center px-4 h-11 border border-hairline hover:border-brand hover:text-brand transition-colors font-heading tracking-tight text-sm">
              Yell
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <h3 className="font-mono text-xs tracking-[0.2em] text-brand mb-6">CONTACT</h3>
          <address className="not-italic space-y-3 text-concrete">
            <a href={BUSINESS.phoneHref} className="block text-stark text-lg hover:text-brand transition-colors">{BUSINESS.phoneDisplay}</a>
            <a href={BUSINESS.emailHref} className="block hover:text-brand transition-colors break-all">{BUSINESS.email}</a>
            <p>{BUSINESS.address}</p>
          </address>
        </div>

        <div className="lg:col-span-3">
          <h3 className="font-mono text-xs tracking-[0.2em] text-brand mb-6">OPENING HOURS</h3>
          <ul className="space-y-3">
            {BUSINESS.hours.map((h) => (
              <li key={h.day} className="flex justify-between gap-4 text-sm border-b border-hairline pb-2">
                <span className="text-concrete">{h.day}</span>
                <span className="text-stark">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h3 className="font-mono text-xs tracking-[0.2em] text-brand mb-6">SITE</h3>
          <ul className="space-y-3 text-concrete">
            <li><a href="/#services" className="hover:text-brand transition-colors">Services</a></li>
            <li><a href="/areas-we-cover" className="hover:text-brand transition-colors">Coverage</a></li>
            <li><a href="/about" className="hover:text-brand transition-colors">About</a></li>
            <li><a href="/#reviews" className="hover:text-brand transition-colors">Reviews</a></li>
            <li><a href="/contact" className="hover:text-brand transition-colors">Contact</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-hairline flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-concrete font-mono tracking-wide">
        <span>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</span>
        <span>{BUSINESS.address}</span>
      </div>
    </div>
  </footer>
);
